import { render, staticRenderFns } from "./TdInfoManagementRoles.vue?vue&type=template&id=1b9cc0e1&scoped=true"
import script from "./TdInfoManagementRoles.vue?vue&type=script&lang=js"
export * from "./TdInfoManagementRoles.vue?vue&type=script&lang=js"
import style0 from "./TdInfoManagementRoles.vue?vue&type=style&index=0&id=1b9cc0e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9cc0e1",
  null
  
)

export default component.exports